<template>
  <div class="container">
    <div v-for="(item, index) in list" :key="index" class="itemBox" :class="index === 0 ? 'firstBox' : ''">
      <div class="appimg" @click="openUrl(item.url)">
        <!-- <img class="img" :src="item.img" /> -->
        <cjImg :src="_getImgUrl(item.img)" object-fit= 'contain'  class="img" alt="" />
        <span class="corner" v-if="item.vip=='true'">{{ `VIP` }}</span>
      </div>
      <div class="name_des">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
// @ is an alias to /src
import { getImgUrl } from '@/utils/tools'
export default {
  name: 'nomalTwo',
  components: {},
  props:{
    source: Array,
    _getImgUrl:Function
  },
   watch: {
    source: {
      handler(nv) {
        console.log('', '', '===>', '*', nv)
        if (nv&&nv.length > 0) {
          this.list = [...nv]
        }
      },
      deep: true,
      // immediate: true
    }
  },
  data() {
    return {
      list: [
        // { name: '应用名', img: require('@/assets/test.png'), update: '234' },
        // { name: '应用名', img: require('@/assets/test.png'), update: '234' },
        // { name: '应用名', img: require('@/assets/test.png'), update: '234' },
        // { name: '应用名', img: require('@/assets/test.png'), update: '234' },
        // { name: '应用名', img: require('@/assets/test.png'), update: '234' },
        // { name: '应用名', img: require('@/assets/test.png'), update: '234' },
        // { name: '应用名', img: require('@/assets/test.png'), update: '234' },
        // { name: '应用名', img: require('@/assets/test.png'), update: '234' },
        // { name: '应用名', img: require('@/assets/test.png'), update: '234' },
        // { name: '应用名', img: require('@/assets/test.png'), update: '234' }
      ]
    }
  },
  async created() {},
  methods: {
    openUrl(link) {
      if(!link){
        return 
      }
      console.log(link,'linklink')
      const regx = /^(http(s?)|tmast|appmarket|vivoMarket|mimarket|anzhimarket|mstore|samsungapps):\/\//gi
      if (!link.match(regx)) {
        // window.open(`https://${adObj.link}`, adObj.name)
        Toast.fail('访问地址异常')
      } else {
        let a = document.createElement('a')
        a.style = 'display: none' // 创建一个隐藏的a标签
        a.download = ''
        a.href = link
        document.body.appendChild(a)
        a.click() // 触发a标签的click事件
        document.body.removeChild(a)
        // window.open(link)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  // height: 100%;
  display: flex;
  gap: 12px 7px;
  flex-wrap: wrap;
  .firstBox {
    width: 100% !important;
    .appimg {
      height: 196px;
      .img {
        width: 100%;
        height: 196px;
        display: block;
        border-radius: 5.22px;
        object-fit: cover;
      }
    }
  }
  .itemBox {
    width: calc(50% - 3.5px);
    .name_des {
      margin-top: 5px;
      font-family: PingFangSC-Semibold;
      font-size: 13px;
      color: #ffffff;
      letter-spacing: -0px;
      font-weight: 600;
      text-align: left;
      /* 基础样式 */
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .appimg {
    width: 100%;
    height: 96px;
    position: relative;
    border-radius: 5.22px;
    .img {
      width: 100%;
      height: 96px;
      display: block;
      border-radius: 5.22px;
      object-fit: cover;
    }
    .corner {
	  width: 30px;
	  height: 20px;
      position: absolute;
      right: 8px;
      top: 4px;
      font-family: PingFangSC-Medium;
      font-size: 11px;
      color: #161616;
      letter-spacing: -0px;
      font-weight: 500;
      background-image: linear-gradient(180deg, #ffe946 0%, #ffc644 100%);
      border-radius: 4px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
    }
  }
}
</style>
